import { swSettings } from "app/common/services/swSettings";

export const itsMyOwnSegment = (userId: string | number) => {
    return +userId === swSettings.user.id;
};
